var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "div",
      { staticClass: "view-applicants-info-list", attrs: { role: "tablist" } },
      [
        _vm._l(_vm.$store.state.viewInfo.viewUserDetailsList, function(
          item,
          index
        ) {
          return _c(
            "b-card",
            { key: index, staticClass: "mb-1", attrs: { "no-body": "" } },
            [
              _c(
                "b-card-header",
                {
                  staticClass: "p-1",
                  attrs: { "header-tag": "header", role: "tab" }
                },
                [
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle",
                          value: "applicant[" + index + "]",
                          expression: "'applicant['+index+']'"
                        }
                      ],
                      attrs: { block: "", href: "#", variant: "outline-info" }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(item.fullname) +
                          " | " +
                          _vm._s(item.nricFin) +
                          " | " +
                          _vm._s(item.companyName) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "b-collapse",
                {
                  attrs: {
                    id: "applicant[" + index + "]",
                    visible: "",
                    accordion: "my-accordion",
                    role: "tabpanel"
                  }
                },
                [
                  _c(
                    "b-card-body",
                    [
                      _c(
                        "b-table",
                        {
                          attrs: {
                            fields: _vm.tableFields,
                            items: [item],
                            bordered: "",
                            striped: "",
                            hover: ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "applicantInfo",
                              fn: function(row) {
                                return [
                                  _c("p", [
                                    _vm._v("Name: " + _vm._s(row.item.fullname))
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      "Nric / Fin: " + _vm._s(row.item.nricFin)
                                    )
                                  ]),
                                  _c("p", [
                                    _vm._v(
                                      "Company: " + _vm._s(row.item.companyName)
                                    )
                                  ])
                                ]
                              }
                            },
                            {
                              key: "workingProfile",
                              fn: function(row) {
                                return _vm._l(row.item.workingProfile, function(
                                  item,
                                  index
                                ) {
                                  return _c("p", [
                                    _c("strong", [_vm._v(_vm._s(index))]),
                                    _vm._v(
                                      ":" +
                                        _vm._s(item || "NIL") +
                                        "\n              "
                                    )
                                  ])
                                })
                              }
                            },
                            {
                              key: "moreInfo",
                              fn: function(row) {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "outline-info"
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          _vm.checkMoreInfo(
                                            row.item,
                                            row.index,
                                            $event.target
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                View More\n              "
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "text-center text-danger my-2",
                              attrs: { slot: "table-busy" },
                              slot: "table-busy"
                            },
                            [_c("strong", [_vm._v("Loading...")])]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        _c(
          "b-modal",
          {
            attrs: {
              id: "viewUserMoreInfoModal",
              title: _vm.viewMoreInfoModal.title,
              "ok-only": ""
            },
            on: {
              hide: function($event) {
                _vm.resetMoreInfoModal($event.target)
              }
            }
          },
          [
            _c("h4", [_vm._v("Files")]),
            !!_vm.viewMoreInfoModal.content.manager.internalTrainingFiles
              ? _c(
                  "div",
                  _vm._l(
                    _vm.viewMoreInfoModal.content.manager.internalTrainingFiles,
                    function(item, index) {
                      return _c("p", [
                        _vm._v("\n          " + _vm._s(index + 1) + " - "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "https://bio-reactorsexyte.sytes.net/uploads/trainingFileUpload/internalTrainingFiles/" +
                                _vm.nricFin +
                                "/" +
                                item,
                              target: "_blank"
                            }
                          },
                          [_vm._v(_vm._s(item))]
                        )
                      ])
                    }
                  )
                )
              : _vm._e(),
            _c("hr"),
            _c("h4", [_vm._v("Booking History")]),
            !!_vm.viewMoreInfoModal.content.moduleSessionList
              ? _c(
                  "div",
                  _vm._l(
                    _vm.viewMoreInfoModal.content.moduleSessionList,
                    function(item, index) {
                      return _c("p", [
                        _vm._v(
                          "\n          " +
                            _vm._s(item.moduleName) +
                            " : " +
                            _vm._s(_vm._f("momentFilter")(item.sessionTime)) +
                            " [ " +
                            _vm._s(item.language) +
                            " ]\n        "
                        )
                      ])
                    }
                  )
                )
              : _vm._e()
          ]
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aedd68c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aedd68c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/dashboard/viewingInfo/ViewApplicantsInfoList.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-aedd68c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/dashboard/viewingInfo/ViewApplicantsInfoList.vue
// module chunks = 2